import { X } from 'lucide-react';
import type { ReactNode } from 'react';

/** Side sheet on desktop, full-width on mobile (§8). Defaults right. */
export function Drawer({
  open,
  onClose,
  title,
  children,
  side = 'right',
}: {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  children: ReactNode;
  side?: 'left' | 'right';
}) {
  if (!open) return null;
  const pos = side === 'left' ? 'left-0 border-r' : 'right-0 border-l';
  return (
    <div className="fixed inset-0 z-40">
      <button
        type="button"
        className="absolute inset-0 h-full w-full cursor-default bg-black/50"
        onClick={onClose}
        aria-label="Close drawer"
      />
      <aside
        className={`absolute ${pos} top-0 h-full w-full sm:w-[440px] overflow-y-auto border-[var(--color-border)] bg-[var(--color-panel)] shadow-xl`}
        aria-label="Detail panel"
      >
        <header className="sticky top-0 flex items-center justify-between border-b border-[var(--color-border)] bg-[var(--color-panel)] px-4 py-3">
          <div className="text-sm font-semibold">{title}</div>
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1 text-[var(--color-muted)] hover:bg-[var(--color-panel-2)]"
            aria-label="Close"
          >
            <X size={16} />
          </button>
        </header>
        <div className="p-4">{children}</div>
      </aside>
    </div>
  );
}
